const messages = {
  welcomeText:
    "Welcome to TRIQUETRA Mitigation Measure Selection & Optimisation Module. Press enter to continue.",

  fetchingText: "Just a moment...",
  errorMessage: "Something went wrong. Please try again later.",
  texts_0: [
    "I am managing a cultural heritage monument located in the area of",
    "which has characteristics such as its",
    "and",
    "while its historical",
    ", ",
    "and",
    "define its unique significance. The site experiences",
    "and",
    "affecting its conservation, and it faces risks categorized by",
    ",",
    "and",
    ".The frequency of these events, noted as",
    ".",
  ],
  texts_1: [
    "I am managing a cultural heritage monument located in the",
    ", specifically in the",
    "area, which is renowned for its unique",
    "environment and historical value. The monument dates back to the",
    "period, and its significance is highlighted by its classification as a(n)",
    ". However, the site is increasingly affected by challenges, including",
    ", which pose a threat to its conservation. Addressing these risks is critical to preserving its legacy for future generations.",
  ],
  short_texts: [
    "I am managing a cultural heritage monument located in the",
    ", specifically in the",
    "area. I want to investigate",
    "of the archeological site, which is renowned for its unique",
    "environment and historical value. The monument dates back to the",
    "period, and its significance is highlighted by its classification as a(n)",
    ". However, the site has",
    "visitation and is increasingly affected by the",
    ", with a",
    "effect that is",
    "to occur. This Climate Phenomenon yield the",
    "with",
    "impact, posing a threat to its conservation. Addressing these risks is critical to preserving its legacy for future generations.",
  ],
  long_texts: [
    "I am managing a cultural heritage monument located in the",
    ", specifically in the",
    "area. I want to investigate",
    "which is renowned for its unique",
    "environment and historical value. The monument dates back to the",
    "period, and its significance is highlighted by its classification as a(n)",
    ". However, the site is increasingly affected by challenges, including",
    ", which pose a threat to its conservation. Addressing these risks is critical to preserving its legacy for future generations.",
  ],
  placeholders_0: {
    pilotArea: "",
    ScaleOfMonument: "",
    ConstructionMaterials: "",
    Period: "",
    NaturalEnvironment: "",
    TypeOfMonument: "",
    ClimatePhenomenon: "",
    CumulativeAndSlowProcesses: "",
    TypeOfRisk: "",
    BySizeEffect: "",
    ByPossibilityOfOccurrence: "",
    Frequency: "",
  },
  placeholders__0: {
    country: "",
    pilotArea: "",
    naturalEnvironment: "",
    period: "",
    typeOfMonument: "",
    typeOfRisk: "",
  },
  short_placeholders: {
    country: "",
    pilotArea: "",
    scaleOfMonument: "",
    naturalEnvironment: "",
    period: "",
    typeOfMonument: "",
    visitation: "",
    typeOfRisk: "",
    sizeEffect: "",
    possibilityOfOccurrence: "",
    cumulativeAndSlowProcesses: "",
    impact: "",
  },
  long_placeholders: {
    country: "",
    pilotArea: "",
    scaleOfMonument: "",
    naturalEnvironment: "",
    period: "",
    typeOfMonument: "",
    typeOfRisk: "",
  },
};

export default messages;
